var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.02 27.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1db2d7;stroke:#1db2d7;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.29,9a1.31,1.31,0,0,0-1.09-.58H16.63a4.75,4.75,0,0,0-.79-2.63,1,1,0,0,0-.2-1.31l-2-1.64a2,2,0,1,0-2.28,1.61,1.55,1.55,0,0,0,.31,0,2.09,2.09,0,0,0,.65-.13l2,1.69a.89.89,0,0,0,.93.16A4.16,4.16,0,0,1,16,8.38H1.81A1.31,1.31,0,0,0,.5,9.69a1.37,1.37,0,0,0,.09.49l2.63,6.57a1.3,1.3,0,0,0,1.22.82H6.92l1.46,6.57h0a2.63,2.63,0,0,0-2.63,2.63H16.26a2.62,2.62,0,0,0-2.62-2.63l1.45-6.57h2.49a1.31,1.31,0,0,0,1.22-.82l2.62-6.57A1.3,1.3,0,0,0,21.29,9Zm-9,15.18H9.69L7.4,13.63h7.23Zm5.26-7.88h-2.2l.53-2.34a1.32,1.32,0,0,0-1-1.57l-.33,0H7.4A1.32,1.32,0,0,0,6.05,13.6a1.66,1.66,0,0,0,0,.32l.55,2.34H4.44L1.81,9.69H20.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/Podium.921abfc9c313fb929fa93a0cc27b8382.svg";
export { ForwardRef as ReactComponent };